import React from 'react';

const LoadingScreen = ({ message = "Loading..." }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 flex items-center justify-center">
      <div className="text-center">
        <div className="relative">
          {/* Logo with animation */}
          <div className="mb-8">
            <img
              src="/logo.svg"
              alt="Uttik"
              className="h-16 w-16 mx-auto object-contain animate-pulse"
            />
          </div>

          {/* Loading spinner */}
          <div className="relative">
            <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-200 border-t-blue-600 mx-auto mb-4"></div>
          </div>

          {/* Loading text */}
          <p className="text-gray-600 text-lg font-medium">{message}</p>

          {/* Dots animation */}
          <div className="flex justify-center mt-2 space-x-1">
            <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
            <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
